import * as React from 'react';

interface DrawerLeftContextProps {
  isOpenDrawerLeft: boolean;
  openDrawerLeft: () => void;
  closeDrawerLeft: () => void;
}

export const DrawerLeftContext = React.createContext<DrawerLeftContextProps>({
  isOpenDrawerLeft: false,
  openDrawerLeft: () => false,
  closeDrawerLeft: () => true
});

interface DrawerLeftProviderProps {
  children: React.ReactNode;
}

export function DrawerLeftProvider({ children }: DrawerLeftProviderProps) {
  const [isOpenDrawerLeft, setIsOpenDrawerLeft] = React.useState(false);
  // Stable identities keep consumers from rebuilding effects and memos on every provider render.
  const openDrawerLeft = React.useCallback(() => setIsOpenDrawerLeft(true), []);
  const closeDrawerLeft = React.useCallback(() => setIsOpenDrawerLeft(false), []);

  const contextValue = React.useMemo(
    () => ({ isOpenDrawerLeft, openDrawerLeft, closeDrawerLeft }),
    [isOpenDrawerLeft, openDrawerLeft, closeDrawerLeft]
  );

  return <DrawerLeftContext.Provider value={contextValue}>{children}</DrawerLeftContext.Provider>;
}
